// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3G-Ec","errors":"Errors_errors__1Vc43"};